import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';

import { environment } from '@/app/environments/environment';
import { IS_AUTHENTICATED, SET_TENANT_DEFAULT, SKIP_LOADING_INDICATOR } from '@/shared/lib/core/interceptors/header-tokens';
import { DataStore } from '@/shared/lib/stores/data.store';
import { DeploymentStore } from '@/shared/lib/stores/deployment.store';
import { NotificationStore } from '@/shared/lib/stores/notification.store';
import { UserStore } from '@/shared/lib/stores/user.store';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const userStore = inject(UserStore);
  const notificationStore = inject(NotificationStore);
  const deploymentStore = inject(DeploymentStore);
  const dataStore = inject(DataStore);
  const key = userStore?.token()?.token;

  req = req.clone({
    setHeaders: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
      'ocp-apim-subscription-key': environment.data.gatewayKey,
      appVersion: dataStore.appInfo()?.version ?? 'local',
      deviceInfo: dataStore.deviceInfo()?.model ?? 'local',
    },
  });

  if (req.context.get(IS_AUTHENTICATED)) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${key}`,
        sub: userStore.userProfile()?.sub ?? '',
      },
    });
  }

  if (req.context.get(SET_TENANT_DEFAULT)) {
    req = req.clone({
      setHeaders: {
        tenantId: deploymentStore.selectedTenantId()?.toString() ?? '',
        deploymentId: deploymentStore.selectedDeploymentId()?.toString() ?? '',
      },
    });
  }

  if (req.context.get(SKIP_LOADING_INDICATOR)) {
    return next(req);
  }

  notificationStore.setLoadingState(req, false);

  return next(req).pipe(
    finalize(() => {
      notificationStore.setLoadingState(req, true);
    }),
  );
};
